import { render, staticRenderFns } from "./CardsPeople.vue?vue&type=template&id=7542f70f&scoped=true"
import script from "./CardsPeople.vue?vue&type=script&lang=js"
export * from "./CardsPeople.vue?vue&type=script&lang=js"
import style0 from "./CardsPeople.vue?vue&type=style&index=0&id=7542f70f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7542f70f",
  null
  
)

export default component.exports